import { Component, Vue } from "vue-property-decorator";
import { FAQ_QUERY } from "@/graphql/faq-query";
import { gql } from "graphql-tag";
import AppLoaderComponent from "../app-loader/app-loader.component.vue";

@Component({
  name: "FaqComponent",
  components: {
    AppLoaderComponent,
  },
})
export default class FaqComponent extends Vue {
  public allCategories: any[] = [];
  public currentTab = "";
  public allFaqs: any[] = [];
  public faqs: any[] = [];
  public expandedIndex: number | null = 0;
  public isLoading = false;

  public get currentCategory(): any {
    const found = this.allCategories.find(
      (c: any) => c.attributes.name === this.currentTab
    );
    return found ? found.attributes : {};
  }

  public get visibleCategories() {
    return this.allCategories.filter((cat: any) =>
      this.allFaqs.some(
        (item: any) => item.attributes.category === cat.attributes.name
      )
    );
  }

  public get sectionDescription() {
    return this.currentCategory.section_description || "";
  }

  public async created() {
    this.isLoading = true;
    try {
      const result = await this.$apollo.query({
        query: gql`
          query ${FAQ_QUERY}
        `,
      });
      const cats = result.data.faqCategories?.data || [];
      this.allCategories = [...cats].sort(
        (a: any, b: any) =>
          (a.attributes.seq_id || 0) - (b.attributes.seq_id || 0)
      );
      this.allFaqs = result.data.faqs.data;
      const visible = this.visibleCategories;
      if (visible.length) {
        this.currentTab = visible[0].attributes.name;
      }
      this.filterData();
    } finally {
      this.isLoading = false;
    }
  }

  public onNavigation(name: string) {
    this.currentTab = name;
    this.expandedIndex = 0;
    this.filterData();
  }

  public filterData() {
    this.faqs = this.allFaqs
      .filter((item: any) => item.attributes.category === this.currentTab)
      .sort(
        (a: any, b: any) =>
          (a.attributes.seq_id || 0) - (b.attributes.seq_id || 0)
      );
  }

  public toggleItem(index: number) {
    this.expandedIndex = this.expandedIndex === index ? null : index;
  }

  public bgStyle(color?: string) {
    return color ? { backgroundColor: color } : {};
  }

  public textStyle(color?: string) {
    return color ? { color } : {};
  }

  public borderStyle(color?: string) {
    return color ? { borderBottomColor: color } : {};
  }

  public colorFor(name: string): string {
    const found = this.allCategories.find(
      (c: any) => c.attributes.name === name
    );
    return found ? found.attributes.color || "" : "";
  }
}
